import { API } from "@/lib/api";

export const causeCoverUrl = (id) => `${API}/causes/${id}/cover`;
export const causeQrUrl = (id) => `${API}/causes/${id}/qr`;
export const globalQrUrl = () => `${API}/payment-settings/global-qr/file`;

let scriptPromise = null;
export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return scriptPromise;
}
